import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import PageLoader from "../components/forms/page-loader";
import { getUserValidated } from "../services/interceptors";
import CommonErrorPage from "../components/Error-Components/common-error-page";
import { useTranslation } from "react-i18next";
import { eventBus } from "../utils/eventBus";
import { EVENTS } from "../utils/eventTypes";

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState(getUserValidated()); // ✅ backend validation
  //const navigate = useNavigate();
  console.log("User validation status:", isValid);

  // Listen for validation state changes
  useEffect(() => {
    const handleValidationSuccess = () => {
      setIsValid(true);
    };

    const handleValidationError = () => {
      setIsValid(false);
    };

    eventBus.on(EVENTS.FETCH_VALIDATE_USER_SUCCESS, handleValidationSuccess);
    eventBus.on(EVENTS.FETCH_VALIDATE_USER_ERROR, handleValidationError);

    return () => {
      eventBus.off(EVENTS.FETCH_VALIDATE_USER_SUCCESS, handleValidationSuccess);
      eventBus.off(EVENTS.FETCH_VALIDATE_USER_ERROR, handleValidationError);
    };
  }, []);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  // 🔄 Still loading auth0 OR validation
  if (isLoading || isValid === null) {
    return <PageLoader open={true} />;
  }

  if (!isAuthenticated) {
    return null;
  }

  // ❌ Authenticated but backend validation failed
  if (!isValid) {
    return (
      <CommonErrorPage
        code="40001"
        title={t("error.40001.title")}
        description={t("error.40001.description")}
        image="/image/computer_cancel.svg"
        actionLabel={t("error.40001.actionLabel")}
        onActionClick={() => window.location.reload()}
      />
    );
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
